import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';
import { EndasureValueDisclaimerComponent } from '../endasure-value-disclaimer/endasure-value-disclaimer.component';

@Component({
    selector: 'app-endasure-vistor-info',
    templateUrl: './endasure-vistor-info.component.html',
    styleUrls: ['./endasure-vistor-info.component.scss'],
    standalone: false
})
export class EndasureVistorInfoComponent {

  private readonly destroy$ = new Subject<void>();
  
  constructor(private readonly endasureService:EndasureService,private readonly cdr:ChangeDetectorRef,  private readonly dialog: MatDialog,){}

  vistorInfoForm = new FormGroup({
    firstName: new FormControl(null),
    lastName: new FormControl(null),
    eMail: new FormControl(null),
    valueDisclaimer: new FormControl(false, { validators: Validators.required }),   
  });

  get form() {
    return this.vistorInfoForm.controls;
  }

 

  ngOnInit() {     
  
    this.endasureService.vistInfoData$.pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      if(data!=null){
        this.vistorInfoForm.patchValue({
          firstName: data.firstName || null,
          lastName: data.lastName || null,
          eMail: data.eMail || null,
          valueDisclaimer: data.valueDisclaimer || false,
        });
      }
     
    })


    this.vistorInfoForm.controls.valueDisclaimer.valueChanges.subscribe(value => {
      this.endasureService.valueDisclaimer$.next(value);
      this.cdr.detectChanges();
    });    
  }


  storeDataOnChange(){
    if(this.vistorInfoForm.valid){
      this.endasureService.vistInfoData$.next(this.vistorInfoForm.value);
      this.cdr.detectChanges();    
    }
  }

  endaSureNxt(){  
    this.storeDataOnChange();
    this.endasureService.currentComponent$.next('fleetInfo');   
     
  }
  openDataProtectionDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    const dialogRef = this.dialog.open(EndasureValueDisclaimerComponent);
    dialogRef.afterClosed().subscribe((data) => {
      if (data) 
        {this.vistorInfoForm.controls['valueDisclaimer'].patchValue(data);
      this.endasureService.vistInfoData$.next(this.vistorInfoForm.value);
        }
    });
  }

ngOnDestroy() {
  // Complete the destroy$ subject to unsubscribe all subscriptions
  this.destroy$.next();
  this.destroy$.complete();
}
}